import { render, staticRenderFns } from "./OvertimeCommentWasAdded.vue?vue&type=template&id=67d4f1b6"
import script from "./OvertimeCommentWasAdded.vue?vue&type=script&lang=js"
export * from "./OvertimeCommentWasAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports